interface MobileMenuItemsParams {
  showCustomisationAndPayment: boolean
  isFriendsAndFamily: boolean
}

export default ({showCustomisationAndPayment, isFriendsAndFamily}: MobileMenuItemsParams) => [
  {
    label: "account.profile.label",
    to: "/profile"
  },
  !isFriendsAndFamily && {
    label: "account.contact.label",
    to: "/settings/contact"
  },
  showCustomisationAndPayment && {
    label: "account.payment.label",
    to: "/settings/payment"
  },
  {
    label: "account.password.label",
    to: "/settings/password"
  },
  {
    label: "account.security.label",
    to: "/settings/security"
  },
  showCustomisationAndPayment && {
    label: "account.customisation.interests.label",
    to: "/settings/customisation/categories"
  }
]
